import React from "react"

import HeaderAppTitle from "../../../layout/top/header/common/app-title/app-title"

export type BreadcrumbCustomItem = {
    className?  : string

    label       : string
    noHover?    : boolean

    onClick?    : func
}

type Props = {
    className?          : string

    breadcrumbItems     : BreadcrumbCustomItem[]

    highlightOnHover?   : boolean
}

// const debug = "BreadcrumbsCustom"
const debug = false

export default function BreadcrumbsCustom(props: Props) {

    const onParentClick = (item: BreadcrumbCustomItem) => {
        debug && console.log(debug, 'onParentClick', item)

        item.onClick?.()
    }

    const lastKey = props.breadcrumbItems.length - 1

    const classes = Classes("ui5-breadcrumbs", props.className, {
        'with-highlight': props.highlightOnHover
    })

    return (
        <div className={classes}>
            {_.map(props.breadcrumbItems, (navigationItem: BreadcrumbCustomItem, key: number) => {
                if (lastKey === key) {
                    return <HeaderAppTitle key          = {key}
                                           className    = "p-0"
                                           name         = {navigationItem.label}
                                           editable     = {false}/>
                } else {
                    const itemClasses = Classes("breadcrumb-item", navigationItem.className)

                    return (
                        <React.Fragment key={key}>
                            <div className={itemClasses}
                                 onClick={() => {
                                     onParentClick(navigationItem)
                                 }}>
                                <div className="label ui5-txt-not-important-small">{navigationItem.label}</div>
                            </div>
                            <div className="separator"/>
                        </React.Fragment>
                    )
                }
            })}
        </div>
    )
}